var React = require('react');

function RecruiterIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m-181 452.6-24.5-24.4c9.8-12.9 7.2-31.3-5.7-41.1s-31.3-7.2-41.1 5.7-7.2 31.3 5.7 41.1c10 7.5 23.6 8 34 1l24.6 24.6c1.9 1.9 5 1.8 6.9-.1 1.9-2 1.9-4.9.1-6.8zm-28-42c0 11.1-9 20.1-20.1 20.1s-20.1-9-20.1-20.1 9-20.1 20.1-20.1c11 0 20 9 20.1 20.1z","fill":"#2a2d58","key":0}),React.createElement("path",{"d":"m-225.9 409v-.1c2.6-2 3.1-5.7 1.1-8.3s-5.7-3.1-8.3-1.1-3.1 5.7-1.1 8.3c.3.4.7.8 1.1 1.1v.1c-3.3.8-5.6 3.8-5.7 7.2v7.5h18.4v-7.5c.1-3.4-2.2-6.3-5.5-7.2z","fill":"#f1b860","key":1})]);
}

RecruiterIcon.defaultProps = {"enableBackground":"new -258 381.4 78.4 79.5","viewBox":"-258 381.4 78.4 79.5"};

module.exports = RecruiterIcon;

RecruiterIcon.default = RecruiterIcon;
